module.exports = __webpack_public_path__ + "static/img/image-wait.039131a1.png";